module.exports = __webpack_public_path__ + "img/total-active-accounts.90d95ce6.svg";